module.exports = __webpack_public_path__ + "img/svg/icon-heart.2571c6c5ad32034551530ef8036fe0e7.svg";